var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 48,
    viewBox: "0 0 54 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.57731 2L2 15.1273H52.5019L44.9246 2H9.57731Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.05243 15.1278C2.02549 18.8256 5.00253 21.8497 8.70025 21.8767C11.482 21.8969 13.9875 20.1996 14.9978 17.5997C16.3247 21.0415 20.1976 22.7523 23.6393 21.4254C25.2424 20.8058 26.549 19.5934 27.2765 18.0375C28.8458 21.3783 32.8264 22.8129 36.1672 21.2368C37.723 20.5027 38.9354 19.2027 39.5551 17.5997C40.8954 21.0482 44.775 22.759 48.2235 21.4187C50.8166 20.4151 52.5207 17.9028 52.5005 15.1211",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82959 21.8828V46.4535H48.4341V21.8828",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2092 26.5645H34.4984C31.623 26.5645 29.292 28.8955 29.292 31.7709V33.4817C29.292 36.3571 31.623 38.6881 34.4984 38.6881H36.2092C39.0847 38.6881 41.4157 36.3571 41.4157 33.4817V31.7709C41.4157 28.8955 39.0847 26.5645 36.2092 26.5645Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4458 45.5579V29.3459C12.5199 27.7361 13.8804 26.4968 15.4902 26.5641H21.5251C23.1349 26.4968 24.4954 27.7361 24.5695 29.3459V45.5579",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.2f955402469fa9830aec5e50589f5b53.svg";
export { ForwardRef as ReactComponent };